import { useState, useEffect } from "react";
import { useAuth } from "auth-context/auth.context";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import SuiBox from "components/SuiBox";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import styles from "pages/profile/components/Header/styles";
import UserApi from "api/userApi";
import ProfileEditor from "./components/profileEditor";
import ProfileImage from "./components/profileImage";
import GroupsBadges from "./components/groupBadges";
import logo from "assets/images/logoCD.svg";

function Header() {
  const [userData, setUserData] = useState(null);
  const { user } = useAuth();
  const classes = styles();

  // Log to verify if `user` is being fetched properly
  useEffect(() => {
    console.log("User from Auth Context:", user);
  }, [user]);

  // Fetch profile data
  const fetchProfileData = async () => {
    try {
      if (!user?.identificacion) {
        console.log("No hay identificación de usuario disponible");
        return;
      }
      const response = await UserApi.fetchUser(user.identificacion);
      setUserData(response.data);
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  useEffect(() => {
    if (user) {
      fetchProfileData();
    }
  }, [user]);

  // Handle profile image change (after upload or delete)
  const handleProfileImageChange = () => {
    fetchProfileData();
  };

  if (!user?.identificacion) {
    return null;
  }

  return (
    <SuiBox position="relative" py={2}>
      <DashboardNavbar absolute light />
      <SuiBox className={classes.profileHeader_background} />
      <img src={logo} alt="Logo" className={classes.logoOverlay} />
      <Card className={classes.profileHeader_profile} style={{ minHeight: "160px" }}>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          style={{ height: "100%" }}
        >
          <Grid item>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <ProfileImage
                  userId={String(user.identificacion)}
                  onProfileImageChange={handleProfileImageChange}
                />
              </Grid>
              <Grid item>
                <SuiBox
                  display="flex"
                  alignItems="center"
                  height="100%"
                  justifyContent="center"
                  className={classes.profileEditorContainer}
                >
                  {userData && (
                    <ProfileEditor
                      userId={String(user.identificacion)}
                      initialData={userData}
                      onSave={setUserData}
                    />
                  )}
                </SuiBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <SuiBox display="flex" justifyContent="center" alignItems="center" height="100%">
              <GroupsBadges groups={user?.groups_det || []} />
            </SuiBox>
          </Grid>
        </Grid>
      </Card>
    </SuiBox>
  );
}

export default Header;
